/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProcessState } from './processState';
import { TransactionLogStatus } from './transactionLogStatus';
import { UssdStatus } from './ussdStatus';

export interface UssdTransactionLogs { 
    id?: string;
    sessionId?: string;
    aggregatorId?: string;
    serviceId?: string;
    subscriberPhoneNumber?: string;
    shortCode?: string;
    serviceProviderId?: string;
    ussdString?: string;
    ussdResult?: string;
    network?: string;
    pageCode?: string;
    userInput?: string;
    performedTransactionDump?: boolean;
    keyNumber?: string;
    ussdStatus?: UssdStatus;
    processState?: ProcessState;
    dateCreated?: Date;
    dateTimeStarted?: Date;
    dateTimeEnded?: Date;
    transactionLogStatus?: TransactionLogStatus;
}